module.exports = __webpack_public_path__ + "static/media/design11.b7773bde.png";